import Card from '@mui/material/Card';
import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import clsx from 'clsx';
import React from 'react';
import './style.css';

interface ItemProps {
	id: string,
	message: string,
	options: {
		variant: string
	}
	children: React.ReactNode
}
type IProps = {
	item: ItemProps,
	className?: string,
    onClose?: (id: string) => void
};

const NotificationCard = (props: IProps) => {
	const { item, className, onClose } = props;
	const { variant } = item.options;

	const handleClose = () => {
		onClose && onClose(item.id);
	};

	const ItemIcon = () => {
		switch (variant) {
			case 'error': {
				return (
					<Icon className="iten-icon opacity-75" color="inherit">
						cancel
					</Icon>
				);
			}
			case 'success': {
				return (
					<Icon className="iten-icon opacity-75" color="inherit">
						check_circle
					</Icon>
				);
			}
			case 'warning': {
				return (
					<Icon className="iten-icon opacity-75" color="inherit">
						error_outline
					</Icon>
				);
			}
			case 'info': {
				return (
					<Icon className="iten-icon opacity-75" color="inherit">
						info
					</Icon>
				);
			}
			default: {
				return null;
			}
		}
	}
	return (
		<Card
			className={clsx(
				'flex items-center relative w-full rounded-16 p-20 min-h-64 shadow',
				variant === 'success' && 'bg-green-600 text-white',
				variant === 'info' && 'bg-blue-700 text-white',
				variant === 'error' && 'bg-red-600 text-white',
				variant === 'warning' && 'bg-orange-600 text-white',
				className
			)}
			elevation={0}
		>
			<ItemIcon />
			<Typography component="div">{item.message}</Typography>
			<IconButton
				disableRipple
				className="close-btn top-0 right-0 absolute p-8"
				color="inherit"
				onClick={handleClose}
			>
				<Icon 
					className=" text-12 opacity-75" 
					color="inherit"
				>
					close
				</Icon>
			</IconButton>
			{item.children}
		</Card>
	);
}

export default NotificationCard;
